"use client";

import Image from "next/image";
import { Images } from "@assets/assets";
import BlogCard from "@/components/BlogCard";
import Loader from "@/components/Loader";
import { BlogListingProps } from "@/lib/Types";

export default function BlogGridView({
  BlogPosts,
  categoryArray,
  isShowAward,
  activeCategory,
  setActiveCategory,
  showLoader,
  handleLoadMore,
  loadingMore,
  hasMore,
}: BlogListingProps) {
  return (
    <>
      {/* Category Filters */}
      <div className="flex flex-col lg:flex-row justify-between pt-4 lg:pt-0 items-start gap-6">
        {/* Category filter */}
        <div className="flex flex-wrap items-center justify-start gap-x-2 gap-y-2 pb-2">
          {/* All Button */}
          <button
            type="button"
            onClick={() => setActiveCategory(null)}
            aria-label="Show all blog posts"
            className={`cursor-pointer px-4 md:px-5 py-2 rounded-full border text-[15px] leading-[140%] transition-colors ${
              activeCategory === null
                ? "bg-[#225BD4] border-[#225BD4] text-white"
                : "bg-[#ECF0F6] border-[#ECF0F6] text-[#00040b]"
            }`}
          >
            All
          </button>

          {categoryArray?.length > 0 &&
            categoryArray?.map((item) => {
              const isActive = item.id === activeCategory;
              return (
                <button
                  key={item.id}
                  type="button"
                  onClick={() => setActiveCategory(item?.id)}
                  aria-label={`Show blogs in category: ${item.name}`}
                  className={`cursor-pointer px-4 md:px-5 py-2 rounded-full border text-[15px] leading-[140%] transition-colors ${
                    isActive
                      ? "bg-[#225BD4] border-[#225BD4] text-white"
                      : "bg-[#ECF0F6] border-[#ECF0F6] text-[#00040b]"
                  }`}
                >
                  {item.name}
                </button>
              );
            })}
        </div>

        {/* Award section */}
        {isShowAward && (
          <div className="flex items-center gap-2 md:gap-4 pb-6 lg:pb-0">
            <Image
              src={Images?.blog.award1}
              alt="Top 15 Latest Mobile Blogs"
              width={115}
              height={115}
              className="h-[58px] w-auto md:h-[72px]"
              sizes="(max-width: 768px) 100vw, (max-width: 1536px) 50vw, 700px"
              priority
              fetchPriority="high"
            />
            <Image
              src={Images?.blog.award2}
              alt="Top 80 Mobile App Blog"
              width={115}
              height={115}
              className="h-[58px] w-auto md:h-[72px]"
              sizes="(max-width: 768px) 100vw, (max-width: 1536px) 50vw, 700px"
              priority
              fetchPriority="high"
            />
          </div>
        )}
      </div>

      {/* Grid */}
      {showLoader ? (
        <div className="flex justify-center items-center w-full py-10">
          <Loader size={80} />
        </div>
      ) : BlogPosts?.length > 0 ? (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mt-8">
            {BlogPosts?.map((b) => (
              <BlogCard
                key={b.id}
                imageSrc={b.image}
                category={b.author}
                title={b.title}
                description={b.excerpt}
                date={b.date}
                href={b.link}
                slug={b.slug}
              />
            ))}
          </div>

          {/* Load More Button */}
          {hasMore && (
            <div className="flex justify-center mt-24">
              <button
                onClick={handleLoadMore}
                disabled={loadingMore}
                aria-label={
                  loadingMore ? "Loading more blogs" : "View more blogs"
                }
                style={{ boxShadow: "0px 4px 30px 0px #0000001A" }}
                className="px-16 py-6 bg-white text-black text-[18px] font-semibold capitalize leading-none text-center inline-flex items-center justify-center rounded-full transition-all duration-300 hover:scale-105 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loadingMore ? "loading..." : "View More Blogs"}
              </button>
            </div>
          )}
        </>
      ) : (
        <div className="flex justify-center items-center w-full py-10 text-gray-500">
          <p>No blogs found.</p>
        </div>
      )}
    </>
  );
}
